module.exports = "/_assets/images/theming/hex-characters/corval-hex-question-answer.png";